import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';
import * as support from '../../actions/support';
import { Observable, Subscription } from 'rxjs';
import { SocialMediaLinks, SocialIcon } from '../../interfaces';

@Component({
  selector: 'edge-vr',
  templateUrl: './vr.component.html',
  styleUrls: ['./vr.component.scss']
})
export class PageVRComponent implements OnInit {
  socialMediaLinks$: Observable<SocialMediaLinks> = this.store.select(
    fromRoot.getSocialMediaLinks
  );
  socialMediaLinksSubscription: Subscription;
  tagline =
    '<span>GoArmy Edge Football VR.</span> Take your training to the next level.';
  socialIcons: Array<SocialIcon>;

  constructor(private store: Store<fromRoot.State>) {}

  ngOnInit(): void {
    this.store.dispatch(support.ToggleSupportPageAction('vr'));

    if (this.socialMediaLinks$) {
      this.socialMediaLinksSubscription = this.socialMediaLinks$.subscribe(
        (links) => {
          this.socialIcons = [
            {
              link: 'https://twitter.com/goarmyedge',
              image: '/assets/images/social/logo-black.png',
              alt: 'Twitter',
              sport: 'Football'
            },
            {
              link: 'https://www.youtube.com/goarmyedge',
              image: '/assets/images/social/youtube.svg',
              alt: 'YouTube',
              sport: 'Football'
            },
            {
              link: 'https://www.facebook.com/GoArmyEdgeFootball/',
              image: '/assets/images/social/facebook.svg',
              alt: 'Facebook',
              sport: 'Football'
            }
          ];
        }
      );
    }
  }
}
